<div id="main-div" fxLayout="row" fxLayoutAlign="center center">
  <ng-content></ng-content>
</div>
